<template>
  <section class="container is-fullheight" style="height: 700px">
    <button class="button is-primary" @click="save">Save</button>
    <div class="panel__top">
      <div class="panel__basic-actions"></div>
    </div>
    <div id="gjs">
      <div class="">Hola</div>
    </div>
    <div id="blocks"></div>
  </section>
</template>

<script>
// import "grapesjs/dist/css/grapes.min.css";
// import "grapesjs-component-code-editor/dist/grapesjs-component-code-editor.min.css";
// import grapesjs from "grapesjs";
// import plugin_webpage from "grapesjs-preset-webpage";
// import plugin_newsletter from "grapesjs-preset-newsletter";
// import component_code_editor from "grapesjs-component-code-editor";

export default {
  name: "ReportEditor",
  components: {},
  data() {
    return {
      editor_instance: null,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
    save() {
      console.log(
        "save",
        this.editor_instance.getHtml(),
        this.editor_instance.getCss()
      );
    },
  },
  mounted() {
    const editor = grapesjs.init({
      container: "#gjs",
      fromElement: true,
      height: "100%",
      width: "auto",
      storageManager: false,
      plugins: [plugin_newsletter, plugin_webpage],
    });
    this.editor_instance = editor;

    editor.Panels.addPanel({
      id: "panel-top",
      el: ".panel__top",
      buttons: [
        {
          id: "visibility",
          active: true, // active by default
          className: "btn-toggle-borders",
          label: "<u>B</u>",
          command: "sw-visibility", // Built-in command
        },
      ],
    });
    editor.Panels.addPanel({
      id: "basic-actions",
      el: ".panel__basic-actions",
      buttons: [
        {
          id: "export",
          className: "btn-open-export",
          label: "Exp",
          command: "export-template",
          context: "export-template", // For grouping context of buttons from the same panel
        },
        {
          id: "show-json",
          className: "btn-show-json",
          label: "JSON",
          context: "show-json",
          command(editor) {
            editor.Modal.setTitle("Components JSON")
              .setContent(
                `<textarea style="width:100%; height: 250px;">${JSON.stringify(
                  editor.getComponents()
                )}</textarea>`
              )
              .open();
          },
        },
      ],
    });
  },
  created() {},
};
</script>

<style scoped>
#gjs {
  border: 3px solid #444;
}

/* Reset some default styling */
.gjs-cv-canvas {
  top: 0;
  width: 100%;
  height: 100%;
}

.panel__top {
  padding: 0;
  width: 100%;
  display: flex;
  position: initial;
  justify-content: center;
  justify-content: space-between;
}
.panel__basic-actions {
  position: initial;
}
</style>
